import React from 'react';
import { get } from 'lodash';
import CloudDetailLink from 'app/components/links/CloudDetailLink';
import { Box, Flex, Text, Heading } from 'core/components';
import { ENTITY_TYPES } from 'shared/hybrid/constants';
import CloudIcon from 'app/views/hybrid/maps/components/CloudIcon';
import SidebarItem from 'app/views/hybrid/maps/components/popovers/SidebarItem';
import CloudMetadata from 'app/views/hybrid/maps/components/popovers/CloudMetadata';

const { FIREWALL } = ENTITY_TYPES.get('aws');

const AwsFirewallDetails = (props) => {
  const { nodeData, topology } = props;

  const { type, id, FirewallId = null } = nodeData;

  let firewallId = FirewallId;
  if (type === FIREWALL) {
    firewallId = id;
  }

  if (!firewallId) {
    return null;
  }

  const firewall = get(topology.Entities, `${[FIREWALL]}.${firewallId}`);

  if (!firewall) {
    return null;
  }

  const keys = ['Name', 'RegionName', 'Firewall.Tags'];

  return (
    <Box>
      <Flex borderBottom="thin" p={2} alignItems="center">
        <CloudIcon cloudProvider="aws" entity={FIREWALL} width={32} height={32} />
        <Box flex={1} ml={1}>
          <Text as="div" muted>
            AWS Firewall Details
          </Text>
          <Heading mb={0} level={4}>
            <CloudDetailLink cloud="aws" detail="firewall_id" value={firewallId}>
              {firewall?.Name || firewallId}
            </CloudDetailLink>
          </Heading>
        </Box>
      </Flex>
      {nodeData && (
        <SidebarItem title="Details" icon="more" popoutTitle={AwsFirewallDetails.PopoutTitle(firewall)}>
          <CloudMetadata node={nodeData} keys={keys} />
        </SidebarItem>
      )}
    </Box>
  );
};

AwsFirewallDetails.PopoutTitle = (firewall) => (
  <Flex alignItems="center">
    <CloudIcon cloudProvider="aws" entity={FIREWALL} />
    <Box ml={1}>{firewall?.Name || firewall?.id}</Box>
  </Flex>
);

export default AwsFirewallDetails;
